import React from 'react'
import {Text, Bg, Img, FaIcon, Action} from '../field'
import renderExtraFields from '../field/ExtraFields'
import {realPath, renderVideo} from '../lib/util'

class BlockText extends React.Component {
	/*componentDidMount() {	
		const {block} = this.props
		
		if(typeof(FB)!=='undefined') {
			const id = `block-${block.uuid}`
			const videos = document.querySelectorAll(`#${id} .fb-video`)
			//console.log(videos)
			if (videos.length>0) FB.XFBML.parse();
        }
	}*/
	
	render() {
		const {entity, block, menu, config, screen} = this.props
		/*
		const id = `block-${block.uuid}`
		
		let style = {}
		if (block.bgColor) style.backgroundColor = block.bgColor
		if (block.ga && block.ga.trim()!=='') style.gridArea = block.ga
		*/
		return (
	<div id={config.id}
		className={config.classes.join(' ')}
		style={config.style}>
		{/*
		className={classes + 
		((block.img||block.video) ?(block.align?` img-${block.align}`:''):'') + 
		(block.contain?' contain':'') + (block.big?' big':'') + 
		(block.bg?' has-bg':'') +
		(block.bgProp?' bg-prop':'') +
		(block.layout?(' ' + block.layout):'')
		}
		style={style}>
		*/}
		
		{config.bg && <Bg bg={config.bg} proportional={block.bgProp} container={`#${config.id} > .block-in`} screen={config.screen}/>}
		{menu}

		<div className='block-in'><div className='content'>
			{(block.video && block.video.trim()!=='')
			?<div className='img'>{renderVideo(block.video)}</div>
			:((block.vid && block.vid.length>0)
				?<div className='img'><video controls playsInline poster={(block.img && block.img.length>0)?realPath(block.img[0].url):undefined}>
    				<source src={realPath(block.vid[0].url)} type="video/mp4"/>
				</video></div>
				:<Img src={block.img} classes='field-img' screen={screen}/>)}
			
		{((block.text && block.text!=='' && block.text!=='<p></p>') || block.icon || block.call) &&
		<div className='text-content'>
			<div className='text-wrap'>
				<FaIcon icon={block.icon}/>
				<Text entity={entity} block={block} fieldName='text' type='block' path={'text'} value={block.text}/>
			<Action call={block.call} action={block.link}/>
			{config.extensions.map((Ext, i) => <Ext key={i} {...this.props}/>)}
			{renderExtraFields(entity, block)}
			</div>
		</div>
		}
		
		</div></div>
	</div>
		)
	}
}
export default BlockText



// WEBPACK FOOTER //
// ./src/fm/block/BlockText.js